import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@design-system/link';
export const ContentListLinkWrapper = ({ LinkComponent = Link, ariaLabel, children, isLinkOnAllContent, path, style, tabIndex, }) => {
    if (isLinkOnAllContent || !path) {
        return children;
    }
    return (_jsx(LinkComponent, Object.assign({ "aria-label": ariaLabel, styledOnlyOnHover: true, tabIndex: tabIndex, to: path }, style, { children: children })));
};
//# sourceMappingURL=ContentListLinkWrapper.js.map